import {Link as RouterLink, useNavigate} from 'react-router-dom';
import {Button, Link} from '@mui/material';
import {MRT_ColumnDef} from 'material-react-table';

import {GeoFilterOption, useGetGeoFilterOptions} from '@entities/common';
import {MrTable} from '@shared/components';
import {
  entityTableCommonProps,
  ROUTE__GEO_FILTER_OPTION__CREATE,
  ROUTE__GEO_FILTER_OPTION__EDIT,
} from '@shared/constants';
import {BaseComponentLayout} from '@shared/layouts';

const columns: MRT_ColumnDef<GeoFilterOption>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
    Cell: ({row}) => {
      const {id, name, logo_url} = row.original;
      return (
        <Link
          component={RouterLink}
          to={ROUTE__GEO_FILTER_OPTION__EDIT.replace(':id', id)}
          sx={{display: 'flex', alignItems: 'center', gap: 1}}
        >
          {logo_url && (
            <img
              src={logo_url}
              alt=""
              width="auto"
              height={24}
              style={{flexShrink: 0}}
            />
          )}
          {name || id}
        </Link>
      );
    },
  },
];

export const GeoCategoryTable = () => {
  const navigate = useNavigate();
  const {data, isPending, error} = useGetGeoFilterOptions();

  const renderContent = (categories: GeoFilterOption[] | undefined) => {
    if (!categories) {
      return null;
    }

    return (
      <MrTable
        columns={columns}
        data={categories}
        renderTopToolbarCustomActions={() => {
          return (
            <Button
              onClick={() => {
                navigate(ROUTE__GEO_FILTER_OPTION__CREATE);
              }}
            >
              Add
            </Button>
          );
        }}
        {...entityTableCommonProps}
        enableRowActions={false}
      />
    );
  };

  return (
    <BaseComponentLayout isPending={isPending} error={error}>
      {renderContent(data)}
    </BaseComponentLayout>
  );
};
